<!-- eslint-disable -->
<template lang="pug">
    .table-responsive-container
        .table-responsive
            table.points__table
                thead.points__thead
                    tr.points__tr--border
                        td.points__td(v-if="user.type !== 'student'")
                            | {{ $i18n.t('common.common_userType_student') }}
                        td.points__td
                            | {{ $i18n.t('progress.progress_table_finishDate') }}
                        td.points__td
                            | {{ $i18n.t('progress.progress_table_homework') }}
                        td.points__td
                            | {{ $i18n.t('progress.progress_table_gameOptions') }}
                        td.points__td
                            | {{ $i18n.t('progress.progress_table_executionTime') }}
                        td.points__td
                            | {{ $i18n.t('progress.progress_table_attempts') }}
                        td.points__td
                            | {{ $i18n.t('progress.progress_table_rightPercent') }}
                        td.points__td
                            | {{ $i18n.t('points.points_historyTable_points') }}
                tbody
                    progress-preview(v-for="progress in items" :progress="progress" :key="progress.id")
</template>

<script>
    /*eslint-disable*/
    import ProgressPreview from './Preview.vue'
    import { mapState } from 'vuex'

    export default {
        props: ['items'],
        computed: {
            ...mapState({
                user: state => state.auth.user
            })
        },
        components: {
            ProgressPreview
        }
    }
</script>

<style lang="scss" scoped>
    .table-responsive-container {
        display: grid;
    }

    .table-responsive {
        overflow-x: auto;
    }

    .points__table {
        margin: 30px 0;
        width: 100%;
        text-align: left;
        border-collapse: collapse;
    }

    .points__thead {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        background-color: #E6E6F8;
    }

    .points__td {
        padding: 13px 8px;
        @include media($md) {
            padding: 10px 20px;
        }
    }

    .points__tr--border {
        border-bottom: 1px solid #E6E6F8;
    }
</style>
